import { render, staticRenderFns } from "./exam_wp.vue?vue&type=template&id=2ed6da56"
import script from "./exam_wp.vue?vue&type=script&lang=js"
export * from "./exam_wp.vue?vue&type=script&lang=js"
import style0 from "./exam_wp.vue?vue&type=style&index=0&id=2ed6da56&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports